import { M_REMEMBER_ACC } from './../../models/M_REMEMBER_ACC';
import { BllRememberAcc } from './../../providers/bll/bll-remember-acc';
import { M_USER } from './../../models/M_USER';
import { Ortak } from './../../providers/ortak';
import { M_SERVICE_INFO } from './../../models/M_SERVICE_INFO';
import { BllServisBilgisi } from './../../providers/bll-servis-bilgisi';
import { HomePage } from './../home/home';
import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, App, MenuController } from 'ionic-angular';
@Component({
  selector: 'page-giris',
  templateUrl: 'giris.html',
})
export class GirisPage {
  Users = [];
  Logins: any;
  sunucuAdresi = "";
  txtkullaniciadi: "";
  txttcno:"";
  txtsifre: any;
  nav: NavController;
  adresler: M_SERVICE_INFO[] = [];
  adres: M_SERVICE_INFO = new M_SERVICE_INFO();
  showServerDropdown: boolean = true;
  girisBilgileriHatirla = false;
  girisSegment = "giris";
  gelenkullanici = [];
  kad: any = {};
  suankitarih;
  kullanicilar: any = { Name: "", Sifre: "" };
  personel: M_USER = new M_USER();
  bllRememberAcc: BllRememberAcc = new BllRememberAcc();
  modelRememberAccounts: M_REMEMBER_ACC[] = [];
  constructor(public navCtrl: NavController,
    public menu: MenuController,
    public ortak: Ortak,
    public bllOrtak: BllOrtak,
    public alert: AlertController,
    public app: App) {
  }

  ionViewDidLoad() {
    this.navCtrl = this.app.getRootNav();
    this.menu.enable(false);
    this.gunkontrol();
    this.ServisAdresGetir();
    this.kullaniciGetir();

  }
  giris(e) {
    if (e.keyCode == 13) {
      this.girisislemi();
    }
  }
  girisislemi() {
    var formData = new FormData();
    formData.append("aranan", this.txtsifre);
    formData.append("kullaniciAdi", this.txtkullaniciadi);
    this.bllOrtak.islem(formData, "Login", "", true).then(a => {
      var sonuc = <any>a;
      this.ortak.storagePersonelEkle(sonuc.SonucObject);
      if (sonuc.Sonuc == 1) {
        this.girisBilgileriniHatirlaIslemleri();
        this.navCtrl.setRoot(HomePage);
        this.menu.enable(false);
      }
      if (sonuc.Sonuc != 1) {
        this.showAlert("Hata", "Kullanıcı Bulunamadı");
      }
    })
  
  }
  ureticigiris()
  {
    var formData = new FormData();
    formData.append("tcno", this.txttcno);
  
    this.bllOrtak.islem(formData, "UreticiLogin", "", true).then(a => {
      var sonuc = <any>a;
      this.ortak.storagePersonelEkle(sonuc.SonucObject);
      if (sonuc.Sonuc == 1) {
        this.girisBilgileriniHatirlaIslemleri();
        this.navCtrl.setRoot(HomePage);
        this.menu.enable(false);
      }
      if (sonuc.Sonuc != 1) {
        this.showAlert("Hata", "Kullanıcı Bulunamadı");
      }
    })
   
  }
  ayarKaydet() {
    var bllServisBilgisi = new BllServisBilgisi();
    bllServisBilgisi.getAll().then(b => {
      var sonuc = <any>b;
      if (sonuc.length > 0) {
        var guncellenecekElement = new M_SERVICE_INFO();
        guncellenecekElement.ADRES = this.sunucuAdresi;
        guncellenecekElement.ID = sonuc[0].ID;
        bllServisBilgisi.servisBilgisiGuncelle(guncellenecekElement);
        this.ortak.storageServisBilgisiEkle(guncellenecekElement);
        this.ortak.showBasicAlert("Bilgi", "Bağlantı bilgileri güncellendi. Kullanıcı adınız ve şifreniz ile sisteme giriş yapabilirsiniz.");
      }
      else {
        var servis = new M_SERVICE_INFO();
        servis.ADRES = this.sunucuAdresi;
        servis.SERVIS_TANIMI = "Sunucu";
        servis.VARSAYILAN = 1;
        bllServisBilgisi.add(servis);
        this.ortak.showBasicAlert("Bilgi", "Yeni servis kaydı yapıldı.");
      }
    });
  }
  showAlert(tittle: string, subTitle: string) {
    let alert = this.alert.create({
      title: tittle,
      subTitle: subTitle,
      buttons: ['Tamam']
    });
    alert.present();
  }
  gunkontrol() {
    this.bllOrtak.islemWithoutPost("GununTarihi", "", false).then(a => {
      var sonuc = <any>a;
      this.suankitarih = this.ortak.tarih(sonuc.SonucObject, "ll");
      this.ortak.storageGunTarihiEkle(sonuc.SonucObject);
    })
  }
  ServisAdresGetir() {
    var bllServisBilgisi = new BllServisBilgisi();
    bllServisBilgisi.getAll({ ID: 1 }).then(a => {
      var sonuc = <any>a;
      this.sunucuAdresi = sonuc[0].ADRES;
    }).catch(x => {
     
    })
  }
  kullaniciGetir() {
    var bllRememberAcc = new BllRememberAcc();
    bllRememberAcc.getAll().then(b => {
      var sonuc = <any>b;
      this.kullanicilar = b[0].Sifre;
      if (this.kullanicilar.length > 1)
        
      this.txtkullaniciadi = sonuc[0].Sifre;
      this.txtsifre = sonuc[0].Name;
      this.girisBilgileriHatirla = true;
    }).catch(x => {
     
    })
  }
  girisBilgileriniHatirlaIslemleri() {
    this.bllRememberAcc.deleteAll2().then(a => {
      if (this.girisBilgileriHatirla == true) {
        var remAcc = new M_REMEMBER_ACC();
        remAcc.Sifre = this.txtkullaniciadi;
        remAcc.Name = this.txtsifre;
        this.bllRememberAcc.addOrUpdate(remAcc).then(b => {
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/giris/giris.ts